<template>
  <div class="container w-full mx-auto px-4">
    <el-breadcrumb separator="/" class="px-0">
      <el-breadcrumb-item>
        <a :href="baseUrl">{{ this.shopName }}</a></el-breadcrumb-item
      >
      <el-breadcrumb-item :to="{ path: $routePage.EC_LINE034 }">{{ $t('ec-line034.title') }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t('ec-line035.title') }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="flex flex-row w-full justify-center">
      <h1 class="text-primary text-xl">{{ title }}</h1>
    </div>
    <div class="w-full mt-8">
      <p class="text-left text-black leading-normal">{{ $t('ec-line035.content.hint1') }}</p>
      <p class="text-left text-black leading-normal">{{ $t('ec-line035.content.hint2') }}</p>
    </div>
    <div class="w-full mx-auto text-center mt-8">
      <el-button class="cancel-btn" @click="onBack">{{ $t('common.action.backToLoginScreen') }}</el-button>
    </div>
  </div>
</template>
<script>
import BreadcrumbMixin from '@/mixins/breadcrumb'

export default {
  mixins: [BreadcrumbMixin],
  data() {
    return {
      title: this.$t('ec-line035.title'),
    }
  },
  methods: {
    onBack() {
      this.$router.push(this.$routePage.EC_LINE031)
    },
  },
  metaInfo() {
    return {
      title: this.title,
    }
  },
}
</script>
